<script setup lang="ts">
  import { trans } from '@bv/utils';

  import CallAction from '../CallAction.vue';

  import AnswerIcon from './AnswerIcon.vue';
</script>

<template>
  <call-action
    class="ringing-animation bg-green-500 hover:bg-green-500/90"
    :title="trans('voip.calls.call_action.answer_trans')"
  >
    <answer-icon />
  </call-action>
</template>

<style lang="scss" scoped>
  .ringing-animation {
    animation: ringing-animation 1s ease-in-out infinite;
  }

  @keyframes ringing-animation {
    0% {
      transform: scale(1) rotateZ(0);
    }
    50% {
      transform: scale(1.2) rotateZ(-10deg);
    }
    75% {
      transform: scale(1) rotateZ(45deg);
    }
    100% {
      transform: scale(1) rotateZ(0);
    }
  }
</style>
